import React, { useEffect } from "react";

import { Field, FieldArray } from "formik";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import { IoTrash } from "react-icons/io5";
import { forNames } from "../../../../../utils/masks";

import {
  Flex,
  Text,
  Divider,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Select,
  Button,
  HStack,
  Icon,
} from "@chakra-ui/react";

import ErrorMessage from "../../../../../components/CustomErrorMessage";
import CustomArrayInput from "../../../../../components/CustomArrayInput";
import CustomDatepickerArray from "../../../../../components/CustomDatepickerArray";

const SupervisaoExterna = ({ formProps }) => {
  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Flex
      flexDir="column"
      bgColor="#FFF"
      p="20px"
      borderRadius="16px"
      mt="20px"
    >
      <Text
        color={"#169499"}
        fontWeight="700"
        fontSize="16px"
        lineHeight="21.6px"
        textTransform="uppercase"
      >
        Supervisão Externa
      </Text>
      <Divider orientation="horizontal" mt="10px" />
      <Grid
        templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(2, 1fr)" }}
        gap="20px"
        rowGap="15px"
        mt="20px"
      >
        <GridItem colSpan={1}>
          <Field name="possuiSupervisaoExterna">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.possuiSupervisaoExterna &&
                  form.touched.possuiSupervisaoExterna
                }
                id="possuiSupervisaoExterna"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="possuiSupervisaoExterna"
                >
                  Possui Supervisão Externa?*
                </FormLabel>
                <Select
                  {...field}
                  h="42px"
                  name="possuiSupervisaoExterna"
                  id="possuiSupervisaoExterna"
                  placeholder="Selecione"
                  backgroundColor="white"
                >
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </Select>
                <FormErrorMessage>
                  {form.errors.possuiSupervisaoExterna}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
      </Grid>
      {formProps.values.possuiSupervisaoExterna === "S" && (
        <>
          <FieldArray name="listaSupervisaoExterna">
            {(arrayHelpers) => (
              <>
                {formProps.values.listaSupervisaoExterna &&
                formProps.values.listaSupervisaoExterna.length > 0 ? (
                  formProps.values.listaSupervisaoExterna.map(
                    (supervisaoExterna, index) => (
                      <Grid
                        key={index}
                        templateColumns={{
                          base: "repeat(1, 1fr)",
                          lg: "repeat(2, 1fr)",
                        }}
                        gap="20px"
                        rowGap="15px"
                        mt="20px"
                      >
                        <GridItem colSpan={1} d="flex" flexDir="column">
                          <CustomArrayInput
                            name={`listaSupervisaoExterna[${index}].nomeEntidade`}
                            label={"Nome do Supervisor Externo*"}
                            placeholder={"Informe o Nome do Supervisor"}
                            maxLength={255}
                            onChange={(e) =>
                              formProps.setFieldValue(
                                `listaSupervisaoExterna[${index}].nomeEntidade`,
                                forNames(e.target.value)
                              )
                            }
                          />
                          <Text color="#e53e3e" fontSize="12px">
                            <ErrorMessage
                              name={`listaSupervisaoExterna[${index}].nomeEntidade`}
                            />
                          </Text>
                        </GridItem>
                        <GridItem colSpan={1} d="flex" flexDir="column">
                          <CustomArrayInput
                            name={`listaSupervisaoExterna[${index}].nomeSupervisor`}
                            label={"Órgão/Entidade do Supervisor Externo*"}
                            placeholder={
                              "Informe o Órgão/Entidade do Supervisor Externo"
                            }
                            maxLength={255}
                            onChange={(e) =>
                              formProps.setFieldValue(
                                `listaSupervisaoExterna[${index}].nomeSupervisor`,
                                forNames(e.target.value)
                              )
                            }
                          />
                          <Text color="#e53e3e" fontSize="12px">
                            <ErrorMessage
                              name={`listaSupervisaoExterna[${index}].nomeSupervisor`}
                            />
                          </Text>
                        </GridItem>
                        <GridItem colSpan={1} d="flex" flexDir="column">
                          <CustomDatepickerArray
                            name={`listaSupervisaoExterna[${index}].dataInicio`}
                            arrayFieldName={"listaSupervisaoExterna"}
                            index={index}
                            fieldName={"dataInicio"}
                            label={"Início da Supervisão*"}
                            placeholder={"DD/MM/AAAA"}
                          />
                          <Text color="#e53e3e" fontSize="12px">
                            <ErrorMessage
                              name={`listaSupervisaoExterna[${index}].dataInicio`}
                            />
                          </Text>
                        </GridItem>
                        <GridItem colSpan={1} d="flex" flexDir="column">
                          <HStack spacing="10px" alignItems="flex-end">
                            <CustomDatepickerArray
                              name={`listaSupervisaoExterna[${index}].dataFim`}
                              arrayFieldName={"listaSupervisaoExterna"}
                              index={index}
                              fieldName={"dataFim"}
                              label={"Fim da Supervisão (se houver)"}
                              placeholder={"DD/MM/AAAA"}
                            />
                            <Icon
                              d={index === 0 ? "none" : "block"}
                              aria-label="Excluir estatuto"
                              color="#9EA1AE"
                              as={IoTrash}
                              boxSize="25px"
                              _hover={{ cursor: "pointer" }}
                              onClick={() => arrayHelpers.remove(index)}
                              marginBottom="8px !important"
                            />
                          </HStack>
                          <Text color="#e53e3e" fontSize="12px">
                            <ErrorMessage
                              name={`listaSupervisaoExterna[${index}].dataFim`}
                            />
                          </Text>
                        </GridItem>
                      </Grid>
                    )
                  )
                ) : (
                  <div />
                )}
                <Button
                  id="button-adicionar-supervisao-externa"
                  mt="15px"
                  mb="15px"
                  w="max-content"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={500}
                  fontSize="13px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  onClick={() => {
                    arrayHelpers.push({
                      id: 0,
                      nomeEntidade: "",
                      nomeSupervisor: "",
                      dataInicio: "",
                      dataFim: "",
                    });
                  }}
                >
                  Adicionar
                </Button>
              </>
            )}
          </FieldArray>
        </>
      )}
    </Flex>
  );
};

export default SupervisaoExterna;
